import { Badge } from "@/components/ui/badge";

const ProblemStatement = () => {
  return (
    <section className="py-24 px-8">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8">
          <Badge variant="outline" className="mb-4 font-light">
            The Post-House v. NCAA Reality
          </Badge>
        </div>
        <blockquote className="border-l-2 border-primary/30 pl-8 fade-on-scroll">
          <p className="text-[28px] font-light leading-[1.4] text-foreground mb-6">
            Athletic departments now manage $22M+ in annual revenue sharing, hundreds of NIL deals, and Title IX equity requirements — while facing NCAA investigations that can cost $5-11M per violation.
          </p>
          <p className="text-lg font-light text-muted-foreground">
            <span className="font-medium text-foreground">NIL marketplaces</span> (Opendorse, INFLCR) help athletes find deals. <span className="font-medium text-foreground">AthleteNexus</span> protects institutions from compliance disasters.
          </p>
        </blockquote>
      </div>
    </section>
  );
};

export default ProblemStatement;
